// Config for production environment only
const config = {
  API_BASE: 'https://images.homebrands.no',
  DOWNLOAD_API: 'https://images.homebrands.no',
  TOKEN: 'aQN12sN36pP2ecA4LNahIgL5pMaEMj6Emtec1IMFVtc6iH9M8p',
  DOCUMENT_BASE_ID: '456',
  ROUTE_PATTERN: /\/([\w,]+)$/,
};

export default config;
